export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "saishi-zixun",
    name: "赛事资讯",
    description: "最新体育赛事动态、赛程安排与比赛结果速递",
    icon: "ri-live-line",
  },
  {
    slug: "shuju-fenxi",
    name: "数据分析",
    description: "深度赛事数据解读、球队球员统计与趋势预测",
    icon: "ri-bar-chart-line",
  },
  {
    slug: "xiazai-zhinan",
    name: "下载指南",
    description: "大满贯APP各版本下载教程与安装问题解答",
    icon: "ri-download-2-line",
  },
  {
    slug: "shiyong-jiaocheng",
    name: "使用教程",
    description: "APP功能介绍、操作指南与使用技巧分享",
    icon: "ri-book-open-line",
  },
  {
    slug: "hangye-dongtai",
    name: "行业动态",
    description: "体育科技行业新闻、市场趋势与产品更新公告",
    icon: "ri-newspaper-line",
  },
  {
    slug: "yonghu-gushi",
    name: "用户故事",
    description: "大满贯用户的真实体验分享与使用心得交流",
    icon: "ri-user-heart-line",
  },
];